import React from 'react';
import { Hero } from '../components/Hero';
import { CarriersBar } from '../components/CarriersBar';
import { CoverageGrid } from '../components/CoverageGrid';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { HowItWorks } from '../components/HowItWorks';
import { Testimonials } from '../components/Testimonials';
import { QuoteCTA } from '../components/QuoteCTA';
export function Home() {
  return <main data-id="element-365">
      <Hero data-id="element-366" />
      <CarriersBar data-id="element-367" />
      <CoverageGrid data-id="element-368" />
      <WhyChooseUs data-id="element-369" />
      <HowItWorks data-id="element-370" />
      <Testimonials data-id="element-371" />
      <QuoteCTA data-id="element-372" />
    </main>;
}